import React, { HtmlHTMLAttributes, useEffect } from 'react';
import AOS from 'aos';
interface AuthLayoutProps extends HtmlHTMLAttributes<HTMLDivElement> {

}
const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
    useEffect(() => {
        AOS.init();
    }, [])

    return (
        <div className="login_page">
            <div className="login_left" data-aos="fade-right">
                {children}
            </div>
            <div className="login_right" data-aos="fade-left"></div>
        </div>
    );
};

export default AuthLayout;